import { useState } from "react";
import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
} from "react-simple-maps";
import { motion, AnimatePresence } from "framer-motion";
import { cities } from "../../data/cities";
import CityModal from "./CityModal";

const geoUrl = "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json";

export default function InteractiveMap() {
  const [selectedCity, setSelectedCity] = useState(null);

  return (
    <div className="relative">
      <ComposableMap
        projectionConfig={{ scale: 140, center: [20, 20] }}
        className="w-full h-auto"
      >
        <Geographies geography={geoUrl}>
          {({ geographies }) =>
            geographies.map((geo) => (
              <Geography
                key={geo.rsmKey}
                geography={geo}
                fill="#1e1e2e"
                stroke="#2a2a3e"
                strokeWidth={0.5}
                style={{
                  default: { outline: "none" },
                  hover: { fill: "#2a2a3e", outline: "none" },
                  pressed: { outline: "none" },
                }}
              />
            ))
          }
        </Geographies>
        {cities.map((city) => (
          <Marker
            key={city.name}
            coordinates={city.coordinates}
            onClick={() => setSelectedCity(city)}
          >
            <motion.circle
              r={6}
              fill="#7dd3fc"
              stroke="#0a0a0f"
              strokeWidth={2}
              whileHover={{ scale: 1.5 }}
              className="cursor-pointer"
              style={{ filter: "drop-shadow(0 0 6px rgba(125,211,252,0.5))" }}
            />
            <text
              textAnchor="middle"
              y={-12}
              className="text-[10px] font-medium select-none pointer-events-none"
              fill="#8892a4"
            >
              {city.name}
            </text>
          </Marker>
        ))}
      </ComposableMap>

      <AnimatePresence>
        {selectedCity && (
          <CityModal
            city={selectedCity}
            onClose={() => setSelectedCity(null)}
          />
        )}
      </AnimatePresence>
    </div>
  );
}
